import { Layout } from '../Layout';
import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import SearchResultsWork from '../dashboard/SearchResultsWork';
import * as React from 'react';
import { ReactNode, useContext, useState } from 'react';
import { AuthContext } from '../../Auth/components/AuthProvider';
import { NavigateFunction, Params, useNavigate, useParams } from 'react-router';
import { IntlShape, useIntl } from 'react-intl';
import { Publists } from './publists/Publists';
import { UserAvatarComponent } from '../components/UserAvatar';
import { ExternalId } from '../detail/components/ExternalId';

interface Tab {
  key: string;
  content: ReactNode;
}

export const ProfilePage: () => ReactNode = (): ReactNode => {
  const intl: IntlShape = useIntl();
  const {user} = useContext(AuthContext);
  const params: Readonly<Params<string>> = useParams();
  const navigate: NavigateFunction = useNavigate();
  const [activeTab, setActiveTab] = useState<number>(0);



  const tabs: Tab[] = [
    {
      key: 'works',
      content:
        <div className={'p-3'}>
          {user?.personId ? <SearchResultsWork
            externalParams={{queryString: `person_id:${user.personId}`}}></SearchResultsWork> : intl.formatMessage({id: 'noDataAvailable'})}
        </div>,
    },
    {
      key: 'publists',
      content:
        <Publists/>,
    },
  ];

  if (params.tab) {
    const index: number = Math.max(0, tabs.map((tab: Tab): string => tab.key).indexOf(params.tab));
    if (activeTab !== index) setActiveTab(index);
  }

  return (
    <Layout loading={!user} title={'Profil'}>
      {user && (
        <div className="flex flex-wrap gap-4 justify-content-center">
          <div className={'w-10rem h-10rem'}>
            <UserAvatarComponent type={'large'} currentUser={true} />
          </div>
          <div className={'flex flex-column h-10rem gap-4'}>
            <div className={'flex-1 align-items-center text-5xl'}>
              {user.givenname} {user.surname}
            </div>
            {user?.orcidAuthorize?.orcidID &&
              <div>
                <ExternalId id={{ externalId: user.orcidAuthorize.orcidID, type: 'orcid' }} entity={'person'} />
              </div>
            }
            <div className={'flex-1 align-items-center text-3xl'}>{user.username}</div>
          </div>
        </div>
      )}
      <TabView
        activeIndex={activeTab}
        onTabChange={(event: TabViewTabChangeEvent): void => void navigate(`/user/profile/${tabs[event.index].key}`)}
        pt={{ panelContainer: { className: 'p-0' } }}
      >
        {tabs.map(
          (tab: Tab): ReactNode => (
            <TabPanel header={intl.formatMessage({ id: `entity.${tab.key}` })}>{tab.content}</TabPanel>
          )
        )}
      </TabView>
    </Layout>
  );
};

export default ProfilePage;
